import { ICountry } from 'legacy/lut/classes/models/dictionaries/countries/countries'

import { I74Form } from 'clickNgo/models/crud/forms/i74Form'

export const mapCountryFrom74Form = (data: I74Form): ICountry => ({
  amplifyInsightCluster: data.AmplifyInsightCluster,
  bg: data.bg,
  cluster: data.Cluster,
  code: data.CC,
  name: data.en,
  countryCluster: data.CountryCluster,
  cs: data.cs,
  da: data.da,
  de: data.de,
  defaultCurrencyCode: data.DefaultCurrencyCode,
  defaultLanguageCode: data.DefaultLanguageCode,
  dnACluster: data.DnACluster,
  dnADistrict: data.DnADistrict,
  el: data.el,
  en: data.en,
  en_gb: data.en_gb,
  entryId: data.EntryId,
  es: data.es,
  fi: data.fi,
  fr: data.fr,
  he: data.he,
  hpOrg: data.HPOrg,
  hpSubOrg: data.HPSubOrg,
  hr: data.hr,
  hu: data.hu,
  it: data.it,
  jbpGeoUnit: data.JBPGeoUnit,
  market: data.MarketL2,
  mdmId: data.MDM_ID,
  nl: data.nl,
  no: data.no,
  phoneCountryCode: data.PhoneCode,
  pl: data.pl,
  proxyStockCC: data.ProxyStockCC,
  pt: data.pt,
  region: data.GeoRegion,
  regionL0: data.RegionL0,
  regionL1: data.RegionL1,
  regionL2: data.RegionL2,
  regionL3: data.RegionL3,
  regionL4: data.RegionL4,
  ro: data.ro,
  ru: data.ru,
  se: data.se,
  sk: data.sk,
  sl: data.sl,
  status: data.Status,
  subMarket: data.GeoSubMarket,
  tr: data.tr,
})
